import React from 'react';

interface CampaignIdeasSkeletonProps {
  badgeColor: 'blue' | 'green' | 'purple' | 'orange';
  badgeWidth?: string;
}

const CampaignIdeaSkeleton: React.FC<CampaignIdeasSkeletonProps> = ({ 
  badgeColor, 
  badgeWidth = 'w-24' 
}) => {
  const getBadgeColorClass = () => {
    switch (badgeColor) {
      case 'blue':
        return 'bg-blue-500/20';
      case 'green':
        return 'bg-green-500/20';
      case 'purple':
        return 'bg-purple-500/20';
      case 'orange':
        return 'bg-orange-500/20';
    }
  };

  return (
    <div className="bg-[#2a2a2a] rounded-lg p-4 border border-gray-700 animate-pulse">
      <div className={`h-5 ${getBadgeColorClass()} rounded-full ${badgeWidth} mb-3`}></div>
      <div className="h-3 bg-gray-700 rounded w-16 mb-2"></div>
      <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
      <div className="h-3 bg-gray-700 rounded w-20 mb-1"></div>
      <div className="h-3 bg-gray-700 rounded w-24"></div>
    </div>
  );
};

export default CampaignIdeaSkeleton;
